import React, { useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { validateAssignedTo } from "../../utils/ticketAssignmentUtils";
import "./assignmentControl.css";

const AssignmentControl = ({
  value,
  agentOptions,
  loading,
  error,
  onChange,
  onAssign,
  onUnassign,
  className = "",
}) => {
  const [inlineError, setInlineError] = useState("");

  const validationMessage = useMemo(
    () => validateAssignedTo(value, { required: true }),
    [value]
  );

  const resolvedError = inlineError || error || "";

  const handleAssign = async () => {
    const message = validateAssignedTo(value, { required: true });
    if (message) {
      setInlineError(message);
      return;
    }
    setInlineError("");
    await onAssign();
  };

  const handleUnassign = async () => {
    setInlineError("");
    await onUnassign();
  };

  return (
    <div className={`assignment-control ${className}`.trim()}>
      <Dropdown
        value={value}
        options={agentOptions}
        optionLabel="label"
        optionValue="value"
        placeholder="Select agent"
        onChange={(event) => {
          setInlineError("");
          onChange(event.value || "");
        }}
        showClear
        disabled={loading}
        className="assignment-control-dropdown"
      />
      <button
        type="button"
        className="assignment-btn assign"
        onClick={handleAssign}
        disabled={loading || Boolean(validationMessage)}
      >
        {loading ? "Assigning..." : "Assign"}
      </button>
      <button
        type="button"
        className="assignment-btn unassign"
        onClick={handleUnassign}
        disabled={loading}
      >
        Unassign
      </button>
      {resolvedError ? <div className="assignment-inline-error">{resolvedError}</div> : null}
    </div>
  );
};

export default AssignmentControl;
